<template>
  <section id="order" class="order-steps-container">
    <product-order-cart
      :secure="secure"
      :to-select="toSelect"
      :standalone="true"
    ></product-order-cart>
  </section>
</template>

<script>
import ProductOrderCart from './ProductOrderCart.vue'
export default {
  components: {
    ProductOrderCart
  },
  props: {
    secure: {
      type: Boolean,
      default: false
    },
    toSelect: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
.order-steps-container {
  padding-top: 50px;
}

@media screen and (min-width: 620px) {
  .order-steps-container {
    top: 95px;
  }
}
@media screen and (min-width: 768px) {
  .order-steps-container {
    top: 95px;
  }
}

@media screen and (min-width: 1024px) {
  .order-steps-container {
    //    top: 145px;
    top: max(50vh - 413px, 139px);
    //margin-left: 298px;
    //max-width: 1210px;
    //margin-right: 32px;
  }
}
</style>
